<template>
  <section
    class="calc"
    v-if="microsite && microsite?.linkTravel || microsite?.linkProperty || microsite?.linkCar || microsite?.linkAccident || microsite?.linkMortgage || microsite?.linkLifeInsurance"
  >
    <div>
      <div>
        <h2>Spočítej si</h2>
        <ul>
          <li v-if="microsite?.linkTravel">
            <a :href="microsite?.linkTravel">Cestovní pojištění</a>
          </li>
          <li v-if="microsite?.linkProperty">
            <a :href="microsite?.linkProperty">Majetkové pojištění</a>
          </li>
          <li v-if="microsite?.linkCar">
            <a :href="microsite?.linkCar">Povinné ručení</a>
          </li>
          <li v-if="microsite?.linkAccident">
            <a :href="microsite?.linkAccident">Havarijní pojištění</a>
          </li>
          <li v-if="microsite?.linkMortgage">
            <a :href="microsite?.linkMortgage">Hypotéka</a>
          </li>
          <li v-if="microsite?.linkLifeInsurance">
            <a :href="microsite?.linkLifeInsurance">Životní pojištění</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useMicrositeStore } from '../../stores/useMicrositeStore'
import { computed } from 'vue'

const microsite = computed(() => {
  const store = useMicrositeStore()
  return store.microsite
})

</script>
